import { OperationOutcome } from "fhir/r4"

export async function logout(token: string): Promise<null | OperationOutcome> {
  if (token.length === 0) {
    return null
  }

  const response = await fetch(`/api/auth/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    return (await response.json()) as OperationOutcome
  }

  return null
}
